// import React, { useState } from "react";
// import { FaBars } from "react-icons/fa";

// const components = {
//   Home: () => <div className="p-4">این محتوای خانه است</div>,
//   Profile: () => <div className="p-4">این محتوای پروفایل است</div>,
//   Settings: () => <div className="p-4">این محتوای تنظیمات است</div>,
// };

// export default function ToolsSidebar() {
//   const [activeComponent, setActiveComponent] = useState("Home");
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const ComponentToShow = components[activeComponent];

//   return (
//     <div className="flex h-screen bg-gray-100">
//       {/* دکمه موبایل */}
//       <button
//         className="lg:hidden fixed top-4 right-4 z-50 p-2 bg-gray-900 text-white rounded-md shadow-lg"
//         onClick={() => setSidebarOpen(!sidebarOpen)}
//       >
//         <FaBars size={20} />
//       </button>

//       {/* سایدبار */}
//       <div
//         className={`fixed top-20 left-0 h-full w-64 bg-white shadow-lg z-40 transform transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "translate-x-full"} lg:translate-x-0 lg:relative lg:w-1/4`}
//       >
//         <div className="flex flex-col p-4 space-y-3 h-full">
//           {Object.keys(components).map((key) => (
//             <button
//               key={key}
//               className={`text-left px-4 py-2 rounded-md hover:bg-gray-200 transition
//               ${activeComponent === key ? "bg-gray-200 font-semibold" : ""}`}
//               onClick={() => {
//                 setActiveComponent(key);
//                 setSidebarOpen(false); // برای موبایل سایدبار بسته شود
//               }}
//             >
//               {key}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* محتوای اصلی */}
//       <div className="flex-1 lg:w-3/4 p-6 overflow-auto">
//         <ComponentToShow />
//       </div>
//     </div>
//   );
// }
// import React, { useState } from "react";
// import { FaBars } from "react-icons/fa";

// const components = {
//   HTTP: () => <div className="p-4">این محتوای خانه است</div>,
//   FormFilling: () => <div className="p-4">این محتوای پروفایل است</div>,
//   Settings: () => <div className="p-4">این محتوای تنظیمات است</div>,
// };

// export default function Dashboard() {
//   const [activeComponent, setActiveComponent] = useState("FormFilling");
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const ComponentToShow = components[activeComponent];

//   return (
//     <div className="flex h-screen bg-gray-100">
//       {/* دکمه موبایل */}
//       <button
//         className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-gray-900 text-white rounded-md shadow-lg"
//         onClick={() => setSidebarOpen(!sidebarOpen)}
//       >
//         <FaBars size={20} />
//       </button>

//       {/* سایدبار */}
//       <div
//         className={`fixed top-20 left-0 h-full w-64 bg-white shadow-lg z-40 transform transition-transform duration-300
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 lg:relative lg:w-1/4`}
//       >
//         <div className="flex flex-col p-4 space-y-3 h-full">
//           {Object.keys(components).map((key) => (
//             <button
//               key={key}
//               className={`text-left px-4 py-2 rounded-md hover:bg-gray-200 transition
//               ${activeComponent === key ? "bg-gray-200 font-semibold" : ""}`}
//               onClick={() => {
//                 setActiveComponent(key);
//                 setSidebarOpen(false); // موبایل بعد از انتخاب گزینه بسته شود
//               }}
//             >
//               {key}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* محتوای اصلی */}
//       <div className="flex-1 lg:w-3/4 p-6 overflow-auto">
//         <ComponentToShow />
//       </div>
//     </div>
//   );
// }

  import { Cog8ToothIcon } from "@heroicons/react/24/outline";
  import { CogIcon } from "lucide-react";
  import React from "react";

  export default function ToolsSidebar({ componentsKeys, activeComponent, setActiveComponent, sidebarOpen, setSidebarOpen }) {
    return (
      <div
        className={`fixed top-16 left-0 h-full w-64 bg-white shadow-lg z-40 transform transition-transform duration-300
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} xl:translate-x-0 xl:relative  xl:flex-shrink-0`}
        // className={`h-full bg-white shadow-lg z-40 transform transition-transform duration-300
        // ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        // fixed top-16 left-0 w-64 sm:relative lg:translate-x-0 lg:w-64`}
      >
        <div className="flex flex-col p-4 space-y-3 h-full">
          <h2 className="text-lg font-bold flex justify-between items-center border-b-2 py-4 text-gray-700">
          
            ابزارهای پایه
            <Cog8ToothIcon className="w-6 h-6 text-gray-700 font-bold" />
          </h2>
          {componentsKeys.map((key) => (
            <button
              key={key}
              className={`text-left px-4 py-2 rounded-md hover:bg-gray-200 transition
                ${activeComponent === key ? "bg-gray-200 font-semibold" : ""}`}
              onClick={() => {
                setActiveComponent(key);
                setSidebarOpen(false); 
              }}
            >
              {key}
            </button>
            
          ))}
          
        </div>
      </div>
    );
  }
